document.addEventListener("DOMContentLoaded", function () {
    /* =====================================================================
   HARD ADD-TO-CART COMBINATION GUARD
   ---------------------------------------------------------------------
    ===================================================================== */

(function () {

    const BLOCKED_DESK_SIZES = [
        "Frame Only",
        "100x60",
        "120x70"
    ];

    const DESK_GROMMET_TEXT = "desk grommets";


    /* ================================================================
       GET CURRENT DESK TOP SIZE
    ================================================================= */

    function getCurrentDeskTopSize() {

        const selected =
            document.querySelector(
                'input[name="Desk Top Size(cm)"]:checked'
            );

        return (
            selected?.value ||
            ""
        ).trim();
    }


    /* ================================================================
       GET MAIN PRODUCT FORM
    ================================================================= */

    function getMainProductForm() {

        const button =
            document.getElementById(
                "geo-add-to-cart"
            );

        if (button) {

            const form =
                button.closest(
                    "form"
                );

            if (form) {
                return form;
            }
        }


        return document.querySelector(
            'form.js-product-form.form[action*="/cart/add"]'
        );
    }


    /* ================================================================
       GET HIDDEN ACCESSORY DATA
    ================================================================= */

    function getAccessoryData(form) {

        if (!form) {

            return {
                groupId: "",
                variantNames: []
            };
        }


        const groupInput =
            form.querySelector(
                'input[name="properties[_accessoryGroupId]"]'
            );


        const namesInput =
            form.querySelector(
                'input[name="properties[_accessoryVariantNames]"]'
            );


        const groupId =
            (
                groupInput?.value ||
                ""
            ).trim();


        const rawNames =
            (
                namesInput?.value ||
                ""
            ).trim();


        const variantNames =
            rawNames
                .split(",")
                .map(name => name.trim())
                .filter(Boolean);


        return {
            groupId,
            variantNames
        };
    }


    /* ================================================================
       CHECK DESK GROMMETS IN FORM DATA
    ================================================================= */

    function formHasDeskGrommets(form) {

        const data =
            getAccessoryData(form);


        const found =
            data.variantNames.some(
                name =>
                    name
                        .toLowerCase()
                        .includes(
                            DESK_GROMMET_TEXT
                        )
            );


        console.log(
            "[PORTHOLE CHECK] Form accessory data:",
            data
        );


        return found;
    }


    /* ================================================================
       CHECK THE ACTUAL ACCESSORY CARD
       ---------------------------------------------------------------
       This is an additional check.

       Even if someone changes:
       display:none
       pointer-events
       disabled
       data-locked

       we don't use those properties.
    ================================================================= */

    function cardHasDeskGrommetsSelected() {

        const cards =
            document.querySelectorAll(
                ".accessory-card"
            );


        for (const card of cards) {

            const cardName =
                (
                    card.dataset.card ||
                    card.querySelector(
                        ".accessory-title"
                    )?.textContent ||
                    ""
                )
                .trim()
                .toLowerCase();


            if (
                !cardName.includes(
                    DESK_GROMMET_TEXT
                )
            ) {
                continue;
            }


            /*
             * Normal selected state
             */
            if (
                card.classList.contains(
                    "active"
                )
            ) {

                return true;
            }


            /*
             * Your button changes to "Added" when selected.
             *
             * This is deliberately checked because you can remove
             * disabled from Inspect Element.
             */

            const addButton =
                card.querySelector(
                    ".accessory-add-btn"
                );


            if (addButton) {

                const buttonText =
                    (
                        addButton.textContent ||
                        ""
                    )
                    .trim()
                    .toLowerCase();


                if (
                    buttonText.includes(
                        "added"
                    )
                ) {

                    return true;
                }
            }
        }


        return false;
    }


    /* ================================================================
       FINAL CHECK
    ================================================================= */

    function checkPortholeCombination() {

        const selectedSize =
            getCurrentDeskTopSize();


        /*
         * Normal sizes → always allowed.
         */

        if (
            !BLOCKED_DESK_SIZES.includes(
                selectedSize
            )
        ) {

            return {
                blocked: false
            };
        }


        const form =
            getMainProductForm();


        if (!form) {

            console.warn(
                "[PORTHOLE CHECK] Product form not found."
            );

            return {
                blocked: false
            };
        }


        const accessoryData =
            getAccessoryData(form);


        /*
         * FIRST:
         * Check the actual hidden accessory data.
         */

        const grommetsInForm =
            formHasDeskGrommets(
                form
            );


        /*
         * SECOND:
         * Check the actual card selection.
         */

        const grommetsInCard =
            cardHasDeskGrommetsSelected();


        console.log(
            "========================================"
        );

        console.log(
            "🚨 PORTHOLE ADD-TO-CART CHECK"
        );

        console.log(
            "Desk Top Size:",
            selectedSize
        );

        console.log(
            "Accessory Group ID:",
            accessoryData.groupId
        );

        console.log(
            "Grommets in form:",
            grommetsInForm
        );

        console.log(
            "Grommets in card:",
            grommetsInCard
        );

        console.log(
            "========================================"
        );


        /*
         * BLOCK if either representation says that Desk Grommets
         * is selected.
         *
         * This is intentional:
         *
         * If the user bypasses the visual lock, but the accessory
         * is still selected in the UI → BLOCK.
         *
         * If the accessory data was already written into the form
         * → BLOCK.
         */

        if (
            grommetsInForm ||
            grommetsInCard
        ) {

            return {
                blocked: true,
                selectedSize,
                groupId:
                    accessoryData.groupId
            };
        }


        return {
            blocked: false
        };
    }


    /* ================================================================
       WARNING MESSAGE
    ================================================================= */
    function getDeskSizeContainer() {
    return (
        document.querySelector('fieldset[data-name="Desk Top Size(cm)"]') ||
        document.querySelector('variant-radios fieldset.js.product-form__input') ||
        null
    );
}

    function showPortholeWarning() {

        let warning = document.getElementById("porthole-combination-warning");

        if (!warning) {
            warning = document.createElement("div");
            warning.id = "porthole-combination-warning";
            warning.setAttribute("role", "alert");
            warning.style.cssText = [
                "color:#ff3b30",
                "border-radius:6px",
                "font-size:14px",
                "font-weight:600",
                "line-height:1.4",
                "text-align:left"
            ].join(";");
        }

        warning.textContent = "Desk Grommets aren't available for this size.";

        const deskSizeContainer = getDeskSizeContainer();
        if (deskSizeContainer && deskSizeContainer.parentNode) {
            deskSizeContainer.parentNode.insertBefore(warning, deskSizeContainer.nextSibling);
        } else {
            document.body.prepend(warning);
        }

        warning.style.display = "block";

        warning.scrollIntoView({ behavior: "smooth", block: "center" });

        // Auto-hide after 10 seconds, OR sooner if the shopper fixes the
        // combination (see hidePortholeWarning() wiring below).
        clearTimeout(warning._timer);
        warning._timer = setTimeout(() => {
            warning.style.display = "none";
        }, 10000);
    }

    function hidePortholeWarning() {
        const warning = document.getElementById("porthole-combination-warning");
        if (!warning) return;
        clearTimeout(warning._timer);
        warning.style.display = "none";
    }

    /* ================================================================
       ⭐ MOST IMPORTANT PART ⭐
       WINDOW + CAPTURE
       ---------------------------------------------------------------
       This runs BEFORE the #geo-add-to-cart button's own click
       handler.

       Do not change true to false.
    ================================================================= */

    window.addEventListener(
        "click",
        function (event) {

            const clickedButton =
                event.target.closest(
                    "#geo-add-to-cart"
                );


            /*
             * Not main Add to Cart.
             */

            if (!clickedButton) {
                return;
            }


            console.log(
                "🟡 MAIN ADD TO CART CLICK DETECTED"
            );


            const result =
                checkPortholeCombination();


            /*
             * Valid → allow normal Shopify code.
             */

            if (
                !result.blocked
            ) {

                console.log(
                    "✅ ADD TO CART ALLOWED"
                );

                return;
            }


            /* ========================================================
               🚨 INVALID COMBINATION
               ======================================================== */

            console.error(
                "🚫🚫🚫 ADD TO CART BLOCKED 🚫🚫🚫",
                result
            );


            /*
             * STOP the click before it reaches the Shopify/theme
             * Add-to-Cart handler.
             */

            event.preventDefault();

            event.stopPropagation();

            if (
                typeof event.stopImmediatePropagation ===
                "function"
            ) {

                event.stopImmediatePropagation();
            }


            /*
             * Prevent the button's default submit behaviour too.
             */

            clickedButton.blur();


            /*
             * Show warning.
             */

            showPortholeWarning();


            /*
             * DO NOT open cart.
             * DO NOT submit form.
             * DO NOT fetch /cart/add.js.
             */

            return false;

        },
        true
    );


    /* ================================================================
       FORM SUBMIT BACKUP
    ================================================================= */

    window.addEventListener(
        "submit",
        function (event) {

            const form =
                event.target;


            if (
                !form ||
                !form.matches ||
                !form.matches(
                    'form.js-product-form.form[action*="/cart/add"]'
                )
            ) {

                return;
            }


            const result =
                checkPortholeCombination();


            if (
                !result.blocked
            ) {

                return;
            }


            console.error(
                "🚫 FORM SUBMISSION BLOCKED",
                result
            );


            event.preventDefault();

            event.stopPropagation();

            if (
                typeof event.stopImmediatePropagation ===
                "function"
            ) {

                event.stopImmediatePropagation();
            }


            showPortholeWarning();

        },
        true
    );

})();
    const storeMoneyFormat = document.querySelector('input#storeMoneyFormat').value;
    /* ---------- PORTHOLE PRODUCT HANDLE CHECK ---------- */
    function isPortholeExemptProduct() {
        const handle = document.body.dataset.productHandle || document.querySelector("[data-product-handle]")?.dataset.productHandle || window.ShopifyAnalytics?.meta?.product?.handle || "";
        return handle === "yo-yo-desk-duo" || handle === "yo-yo-desk-duo-plus";
    }

    let modalSourceCard = null;
    let sliderObserver = null; // holds the MutationObserver so we can pause it during our own DOM writes
                let modalThumbPos = 0;
                let modalActiveIndex = 0;
                    const MODAL_THUMB_VISIBLE = 5; // how many thumbs show at once — tweak to taste

                function renderModalThumbs(card, activeSrc) {
                    const track = document.getElementById("modalThumbTrack");
                    if (!track) return;

                    track.innerHTML = "";
                    modalThumbPos = 0;
                    track.style.transform = "translateX(0px)";

                    const imgNodes = card.querySelectorAll(".accessory-all-images .thumb-img-data");
                    let images = Array.from(imgNodes).map((n) => n.dataset.img).filter(Boolean);

                    images = images.map((src) => (src.startsWith("//") ? "https:" + src : src));

                    if (images.length === 0 && activeSrc) images.push(activeSrc);

                    modalActiveIndex = Math.max(0, images.indexOf(activeSrc));

                    images.forEach((src, index) => {
                        const thumb = document.createElement("img");
                        thumb.src = src;
                        thumb.className = "modal-thumb-item" + (index === modalActiveIndex ? " active" : "");
                        thumb.dataset.fullSrc = src;
                        track.appendChild(thumb);
                    });

                    const modalImg = document.querySelector(".modal-image");
                    if (modalImg && images[modalActiveIndex]) modalImg.src = images[modalActiveIndex];

                    updateModalThumbArrows(track);
                }

                function setActiveModalThumb(index) {
                    const track = document.getElementById("modalThumbTrack");
                    if (!track) return;

                    const items = track.querySelectorAll(".modal-thumb-item");
                    if (!items.length) return;

                    index = Math.max(0, Math.min(items.length - 1, index));
                    modalActiveIndex = index;

                    items.forEach((t, i) => t.classList.toggle("active", i === index));

                    const src = items[index].dataset.fullSrc;
                    const modalImg = document.querySelector(".modal-image");
                    if (modalImg && src) modalImg.src = src;

                                       // Keep the active thumb scrolled into view
                    if (index < modalThumbPos) {
                        modalThumbPos = index;
                    } else if (index >= modalThumbPos + MODAL_THUMB_VISIBLE) {
                        modalThumbPos = index - MODAL_THUMB_VISIBLE + 1;
                    }
                    applyThumbScroll(track);
                    updateModalThumbArrows(track);
                }

                function applyThumbScroll(track) {
                    const items = track.querySelectorAll(".modal-thumb-item");
                    if (!items.length) return;

                    const thumbWidth = items[0].getBoundingClientRect().width;
                    const gap = parseFloat(window.getComputedStyle(track).gap) || 8;
                    track.style.transform = `translateX(-${modalThumbPos * (thumbWidth + gap)}px)`;
                }

                function updateModalThumbArrows(track) {
                    const prevBtn = document.getElementById("modalThumbPrev");
                    const nextBtn = document.getElementById("modalThumbNext");
                    if (!prevBtn || !nextBtn) return;

                    const items = track.querySelectorAll(".modal-thumb-item");

                    // Arrows navigate the IMAGE, not just the scroll strip — disable
                    // only at the true first/last image.
                    prevBtn.disabled = modalActiveIndex <= 0;
                    nextBtn.disabled = modalActiveIndex >= items.length - 1;
                }

                const productModalEl = document.getElementById("productModal");
                if (productModalEl) {
                    productModalEl.addEventListener("click", function (e) {
                        const prevBtn = e.target.closest("#modalThumbPrev");
                        const nextBtn = e.target.closest("#modalThumbNext");
                        const thumbImg = e.target.closest(".modal-thumb-item");

                        if (prevBtn) {
                            e.stopPropagation();
                            setActiveModalThumb(modalActiveIndex - 1);
                            return;
                        }

                        if (nextBtn) {
                            e.stopPropagation();
                            setActiveModalThumb(modalActiveIndex + 1);
                            return;
                        }

                        if (thumbImg) {
                            e.stopPropagation();
                            const track = document.getElementById("modalThumbTrack");
                            const items = Array.from(track.querySelectorAll(".modal-thumb-item"));
                            setActiveModalThumb(items.indexOf(thumbImg));
                        }
                    });
                }
    function updateTabCount() {
        document.querySelectorAll(".accessory-tab").forEach((tab) => {
            const tabName = tab.getAttribute("data-tab");
            const selectedItems = document.querySelectorAll(`.accessory-slider[data-tab="${tabName}"] .accessory-card.active`).length;
            const countDisplay = tab.querySelector(".tab-count");
            countDisplay.textContent = selectedItems > 0 ? ` (${selectedItems})` : "";
        });
    }
    const BUNDLE_CART_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.6 12.4a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L21 7H6"/></svg>';
const BUNDLE_BOX_SVG = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5v8l9 5 9-5V8z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/></svg>';

const bundleImgCache = {};

function loadBundleItemImage(pathname, imgEl) {
    if (!pathname.includes("/products/")) return;
    const url = pathname.replace(/\/$/, "") + ".js";
    if (!bundleImgCache[url]) {
        bundleImgCache[url] = fetch(url)
            .then((r) => (r.ok ? r.json() : null))
            .then((prod) => (prod && prod.featured_image) || null)
            .catch(() => null);
    }
    bundleImgCache[url].then((src) => {
        if (!src) return;
        imgEl.src = src.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i, "_100x.$1$2");
    });
}

function enhanceBundleModal(modal, card) {
    const info = modal.querySelector(".modal-details-info");
    const list = info && info.querySelector("ul, ol");
    if (!list) return;

    // remove empty <p>&nbsp;</p> left by Shopify
    info.querySelectorAll("p").forEach((para) => {
        if (!para.textContent.replace(/\u00a0/g, "").trim()) para.remove();
    });

    const items = Array.from(list.querySelectorAll(":scope > li"));

    const cp = parseFloat(card.querySelector(".color-options .color-circle.active")?.dataset.comparePrice);
    const price = parseFloat(card.dataset.variantPrice);
    const hasSaving = cp && price && cp > price;

    const box = document.createElement("div");
    box.className = "bundle-card";
        box.innerHTML =
        '<div class="bundle-card-head">' +
            '<div class="bundle-card-title">What’s Included</div>' +
            '<div class="bundle-card-badge">' + items.length + " items" + (hasSaving ? " • Great value" : "") + "</div>" +
        "</div>";

    const body = document.createElement("div");
    body.className = "bundle-card-body";

    items.forEach((li) => {
        const a = li.querySelector("a[href]");
        const text = li.textContent.replace(/\s+/g, " ").trim();
        const m = text.match(/^(\d+)\s*[×x]\s*(.+)$/i);
        const qty = m ? m[1] : "1";
        const parts = (m ? m[2] : text).split(/\s+[—–-]\s+/);
        const name = parts.shift();
        const variant = parts.join(" — ");
        const href = a ? a.getAttribute("href") : "";

        const row = document.createElement("div");
        row.className = "bundle-item";
        row.innerHTML =
            '<span class="bundle-item-img"><img alt=""></span>' +
            '<span class="bundle-item-text"><span class="bundle-item-name"></span></span>' +
            '<span class="bundle-item-qty"></span>';

        row.querySelector(".bundle-item-qty").textContent = qty + " ×";

        const nameEl = row.querySelector(".bundle-item-name");
        if (href) {
            const link = document.createElement("a");
            link.href = href;
            link.target = "_blank";
            link.rel = "noopener";
            link.textContent = name;
            nameEl.appendChild(link);
        } else {
            nameEl.textContent = name;
        }
        if (variant) {
            const sub = document.createElement("span");
            sub.className = "bundle-item-variant";
            sub.textContent = variant;
            row.querySelector(".bundle-item-text").appendChild(sub);
        }

        // if (href) {
        //     loadBundleItemImage(new URL(href, window.location.origin).pathname, row.querySelector(".bundle-item-img img"));
        // }
        
        const bundleItemImage = row.querySelector(".bundle-item-img img");

        if (name.trim().toLowerCase() === "ergoflow ergonomic task chair") {
            bundleItemImage.src = "https://cdn.shopify.com/s/files/1/0060/0801/2900/files/Ergoflow_4.jpg?v=1787135679";
            console.log("[Bundle Image] Custom ErgoFlow image applied:", bundleItemImage.src);
        } else if (href) {
            loadBundleItemImage(
                new URL(href, window.location.origin).pathname,
                bundleItemImage
            );
        }


        body.appendChild(row);
    });

    box.appendChild(body);
    list.replaceWith(box);
}

    function openModal(button) {
        const card = button.closest(".accessory-card");
        modalSourceCard = card;
        const modal = document.getElementById("productModal");

        // Image (use separate popup image if exists)
        const popupSource = card.querySelector(".accessory-popup-source");
        const mainImage = card.querySelector(".accessory-image");

               modal.querySelector(".modal-image").src = popupSource && popupSource.src ? popupSource.src : mainImage.src;
        modal.querySelector(".modal-title").textContent =
        card.querySelector(".accessory-title")?.textContent || "";
        const isBundle =
            card.classList.contains("is-bundle-card") ||
            card.closest(".accessory-slider")?.dataset.tab === "bundle";
        modal.classList.toggle("is-bundle", isBundle);
        modal.querySelector(".modal-select").innerHTML = isBundle ? BUNDLE_CART_SVG + "<span>Select Bundle</span>" : "Select";

        // Populate the thumbnail slider for this card's product
        renderModalThumbs(card, modal.querySelector(".modal-image").src);

        const priceContainer = modal.querySelector(".modal-price");
        const rawPrice = card.querySelector(".accessory-price .money")?.textContent?.trim() || "FREE";
        const isFree = rawPrice.toLowerCase() === "free" || rawPrice === "0";
        const vatLabel = document.createElement('span');
        if(isFree){
            priceContainer.innerHTML = 'FREE';
        } else {
            const newPrice = card.dataset.variantPrice;
            const vatLabel = document.createElement('span');
            vatLabel.className = 'vat-text ';
            vatLabel.innerText = ' (Inc. VAT)';
            priceContainer.innerHTML = Shopify.formatMoney(newPrice, storeMoneyFormat);
            priceContainer.appendChild(vatLabel);
        }
        // RRP (compare-at price) + savings for bundles
        const modalRrpEl = modal.querySelector(".modal-rrp-price");
        if (modalRrpEl) {
            const activeCardSwatch = card.querySelector(".color-options .color-circle.active");
            const comparePrice = activeCardSwatch?.dataset.comparePrice;
            const cp = parseFloat(comparePrice);
            const p = parseFloat(card.dataset.variantPrice);
            if (cp && p && cp > p) {
                modalRrpEl.style.display = '';
                let html = '<span>RRP: <s>' + Shopify.formatMoney(comparePrice, storeMoneyFormat) + '</s></span>';
                if (isBundle) {
                    html += '<span class="modal-save-badge">You save ' +
                        Shopify.formatMoney(cp - p, storeMoneyFormat) + '</span>';
                }
                modalRrpEl.innerHTML = html;
            } else {
                modalRrpEl.style.display = 'none';
            }
        }

        /* ---------- NEW: SHOW ALL COLORS ---------- */

        const modalColourLabel = modal.querySelector(".modal-colour-label");
        const modalColourOptions = modal.querySelector(".modal-colour-options");
        modalColourOptions.innerHTML = "";
        const modalColourWrapper = modal.querySelector(".modal-colour");
        const productTitle = card.querySelector(".accessory-title")?.textContent?.trim() || "";

         if (
            productTitle === "Scallop Top" ||
            productTitle === "2 X Scallop Top" ||
            productTitle === "2 X Wave Desktop" ||
            productTitle === "Wave Desktop"
        ) {
            modalColourWrapper.style.display = "none";
        }
        const activeCardColor =card.querySelector(".color-options .color-circle.active")?.title || "Default";

        modalColourLabel.textContent = `Colour: ${formatColorName(activeCardColor)}`;

        // 👇 ADD HERE
        console.log("===== MODAL COLOUR DEBUG =====");
        console.log("Active Card Colour:", activeCardColor);
        console.log("Formatted Colour:", formatColorName(activeCardColor));
        console.log("Modal Colour Wrapper:", modalColourWrapper);

        if (
            activeCardColor &&
            activeCardColor.trim().toLowerCase() === "default title"
        ) {
            console.log("✅ Default Title found - hiding .modal-colour");
            modalColourWrapper.style.display = "none";
        } else {
            console.log("❌ Not Default Title - showing .modal-colour");
            modalColourWrapper.style.display = "block";
        }

        function formatColorName(text) {
            if (!text) return "";
            return text.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
        }
        function formatColorName(text) {
            if (!text) return "";
            return text.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
        }

        const cardColors = card.querySelectorAll(".color-options .color-circle");
        cardColors.forEach((circle) => {
            const clone = circle.cloneNode(true);
            clone.classList.remove("active");

            if (circle.classList.contains("active")) {
                clone.classList.add("active");
            }

            clone.addEventListener("click", () => {
                modal.querySelectorAll(".modal-colour-options .color-circle").forEach((c) => c.classList.remove("active"));

                clone.classList.add("active");
                const colorName = clone.title || clone.dataset.id || "Default";
                const colorImage = clone.dataset.image;
                if(colorImage) {
                    modal.querySelector(".modal-image").src = colorImage;
                }
                const newPrice = clone.dataset.price;
                const isFree = newPrice.toLowerCase() === "free" || newPrice === "0";
                if(isFree){
                    priceContainer.innerHTML = 'FREE';
                } else {
                    const vatLabel = document.createElement('span');
                    vatLabel.className = 'vat-text';
                    vatLabel.innerText = ' (Inc. VAT)';
                    priceContainer.innerHTML = Shopify.formatMoney(newPrice, storeMoneyFormat);
                    priceContainer.appendChild(vatLabel);
                }
                modal.querySelector(".modal-colour-label").textContent = `Colour: ${formatColorName(colorName)}`;

                const realCardColor = card.querySelector(`.color-circle[data-variant-id="${clone.dataset.variantId}"]`);
                if (realCardColor) {
                    realCardColor.click();
                }
            });

            modalColourOptions.appendChild(clone);
        });

        /* ---------- ACCESSORY DETAILS SYNC ---------- */
        const cardName = card.getAttribute("data-card");
        const modalDetails = modal.querySelector(".modal-details");

        if (modalDetails) {
            modalDetails.innerHTML = "";
            const sourceDetail = card.querySelector('.accessory-details-info').innerHTML;
            if (sourceDetail) {
                const info = document.createElement('div');
                info.className = 'modal-details-info';
                info.innerHTML = sourceDetail;
                modalDetails.appendChild(info);
            }
        }
        if (modal.classList.contains("is-bundle")) enhanceBundleModal(modal, card);
        modal.style.display = "flex";
        document.body.classList.add("modal-open");
    }
    document.addEventListener("click", function (e) {
        const closeBtn = e.target.closest(".close");
        if (!closeBtn) return;
        console.log("❌ CLOSE BUTTON CLICKED");
        const modal = closeBtn.closest(".modal");
        if (modal) {
            modal.style.display = "none";
        }
        document.body.classList.remove("modal-open"); // ✅ RESTORE SCROLL
    });

    function closeModal() {
        const modal = document.getElementById("productModal");
        if (!modal) return;
        modal.style.display = "none";
        document.body.classList.remove("modal-open"); // ✅
    }

    // Close modal when clicking outside of it
    window.onclick = function (event) {
        const modal = document.getElementById("productModal");
        if (event.target === modal) {
            closeModal();
        }
    };

    // Attach event listeners to the "i" buttons in the accessory cards
    document.querySelectorAll(".top-right-button").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.stopPropagation();
            openModal(button);
        });
    });

    // Modal SELECT button → same as clicking ADD on the card
    const modalSelectBtn = document.querySelector(".modal-select");
    if (modalSelectBtn) {
        modalSelectBtn.addEventListener("click", () => {
            if (!modalSourceCard) return;
            // Guard: never allow the modal SELECT button to add a card that
            // has been locked/hidden by applyPortholeRules() (e.g. porthole
            // accessories on an incompatible Desk Top Size).
            if (modalSourceCard.dataset.locked === "true") {
                closeModal();
                return;
            }
            const addBtn = modalSourceCard.querySelector(".accessory-add-btn");
            // Trigger existing ADD logic
            if (!modalSourceCard.classList.contains("active")) {
                addBtn?.click();
            }
            const modal = document.getElementById("productModal");
            if (modal) {
                const activeSwatch = modal.querySelector('.modal-colour-options .color-circle.active');
                if (activeSwatch){
                    const activeVariantId = activeSwatch.dataset.variantId;
                    const swatches = modalSourceCard.querySelectorAll(
                        `.color-circle[data-variant-id="${activeVariantId}"]`
                    );

                    swatches.forEach((colorSwatch) => {
                        if (!colorSwatch.classList.contains('active')) {
                            colorSwatch.click();
                        }
                    });
                }
                // Close modal
                modal.style.display = "none";
            }
            closeModal();
        });
    }
    function updateAddButtonsOnLoad() {
        document.querySelectorAll(".accessory-card").forEach((card) => {
            const addButton = card.querySelector(".accessory-add-btn");
            if (!addButton) return;

            if (card.classList.contains("active")) {
                addButton.textContent = "Added";
                addButton.classList.add("added");
            } else {
                addButton.textContent = "Add to Desk";
                addButton.classList.remove("added");
            }

            const colorOptions = card.querySelector(".color-options");
            let selectedValue = colorOptions.querySelector(".color-circle.active");
            let selectedSwatchId = selectedValue.dataset.variantId;
            if (colorOptions && selectedValue) {
                colorOptions.querySelectorAll(".color-circle").forEach((s) => s.classList.remove("active"));
                const targetSwatch = colorOptions.querySelector(`.color-circle[data-variant-id="${selectedSwatchId}"]`);
                if (targetSwatch) targetSwatch.classList.add("active");
            }
        });
    }

    function getProductKeyFromCard(card) {
        return card?.getAttribute("data-card")?.trim() || "";
    }

    function syncAddRemoveAcrossSameProducts(sourceCard, isActive) {
        const productKey = getProductKeyFromCard(sourceCard);
        if (!productKey) return;
        document.querySelectorAll(".accessory-card").forEach((targetCard) => {
            if (targetCard === sourceCard) return;
            const targetKey = getProductKeyFromCard(targetCard);
            if (targetKey !== productKey) return;
            if (targetCard.style.pointerEvents === "none" || targetCard.style.opacity === "0.4") return;

            const btn = targetCard.querySelector(".accessory-add-btn");
            if (isActive) {
                targetCard.classList.add("active");
                if (btn) {
                    btn.textContent = "Added";
                    btn.classList.add("added"); // <-- FIXED
                }
            } else {
                targetCard.classList.remove("active");
                if (btn) {
                    btn.textContent = "Add to Desk";
                    btn.classList.remove("added");
                }
            }
        });
    }

    function syncColorToActiveCards(sourceCard, swatchValue) {
        if (!swatchValue) return;
        document.querySelectorAll(".accessory-card").forEach((targetCard) => {
            if (targetCard === sourceCard) return;
            const currentCardId = targetCard.dataset.productId;
            const swatchCardId = sourceCard.dataset.productId;
            if (currentCardId !== swatchCardId) return;
            if (targetCard.style.pointerEvents === "none" || targetCard.style.opacity === "0.4") return;
            const colorOptions = targetCard.querySelector(".color-options");
            if (!colorOptions) return;

            colorOptions.querySelectorAll(".color-circle").forEach((s) => s.classList.remove("active"));
            const targetSwatch = colorOptions.querySelector(`.color-circle[data-variant-id="${swatchValue}"]`);
            if (targetSwatch) {
                targetSwatch.classList.add("active");
                targetCard.dataset.variantId = targetSwatch.dataset.variantId;
                targetCard.dataset.price = targetSwatch.dataset.price;
                targetCard.dataset.title = targetSwatch.dataset.title;
                targetCard.dataset.image = targetSwatch.dataset.image;
                const rawPrice = targetCard.dataset.price;
                const priceContainer = targetCard.querySelector('.accessory-price.money');
                const isFree = rawPrice.toLowerCase() === "free" || rawPrice === "0";
                if(isFree){
                    priceContainer.innerHTML = 'FREE';
                } else {
                    const newPrice = targetCard.dataset.variantPrice;
                    priceContainer.innerHTML = Shopify.formatMoney(newPrice, storeMoneyFormat);
                }
            }
        });
    }

    updateTabCount();
    updateAddButtonsOnLoad();

    document.querySelectorAll(".accessory-card.active").forEach((card) => {
        const colorValue = card.querySelector(".accessory-card-value")?.value;
        if (colorValue) syncColorToActiveCards(card, colorValue);
        syncAddRemoveAcrossSameProducts(card, true);
    });

    /* ---------- Product slider Prev/Next enable-state reset on tab change ---------- */
    function resetArrowsForTab(slider) {
        const prevBtn = document.getElementById("prodPrevBtn");
        const nextBtn = document.getElementById("prodNextBtn");
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = false;
    }

    function clamp(v, a, b) {
        return Math.max(a, Math.min(b, v));
    }

    // How many cards currently fit -- kept in sync by updateCardsPerRow(),
    // which measures the actual accessory box (not the window).
    let currentCardsPerRow = 3;

    // Given the box's real rendered width, work out the most cards that
    // can fit without any card dropping below MIN_CARD_WIDTH -- capped at
    // maxCards. Tweak MIN_CARD_WIDTH to taste.
    const MIN_CARD_WIDTH = 130;
    const CARD_GAP = 16;

          function computeCardsPerRow(boxWidth, maxCards) {
        for (let n = maxCards; n >= 1; n--) {
            const cardWidth = (boxWidth - CARD_GAP * (n - 1)) / n;
            if (cardWidth >= MIN_CARD_WIDTH) return n;
        }
        return 1;
    }

    function getMaxCardsForScreen() {
        // Screen-width ceiling on top of the box-fit calculation:
        // - 2000px and up: max 4 cards
        // - 1500px up to 2000px: max 3 cards
        // - 1200px up to 1500px: max 2 cards
        // - 768px up to 1200px: max 1 card (narrow sidebar layout)
        // - 500px up to 768px: max 2 cards -- below the 768 breakpoint the
        //   page stacks to a single column, so the box is actually WIDER
        //   here than in the 768-1200 sidebar range above it.
        // - below 500px: max 1 card -- too narrow for 2 cards to stay
        //   above MIN_CARD_WIDTH, so drop to a single card.
        const w = window.innerWidth;
        if (w >= 2000) return 4;
        if (w >= 1500) return 3;
        if (w >= 1350) return 3;
        if (w >= 1000) return 2;
        if (w >= 768) return 1;
        if (w >= 500) return 2;
        return 1;
    }

          function updateCardsPerRow() {
        const container = document.querySelector(".accessory-slider-container");
        if (!container) return currentCardsPerRow;
        const width = container.clientWidth;
        if (!width) return currentCardsPerRow; // not visible/rendered yet, keep previous value
        currentCardsPerRow = computeCardsPerRow(width, getMaxCardsForScreen());
        container.style.setProperty("--cards-per-row", currentCardsPerRow);
        return currentCardsPerRow;
    }

    function getVisibleCount() {
        return currentCardsPerRow;
    }

    function getGapPx(track) {
        const cs = window.getComputedStyle(track);
        const gap = cs.getPropertyValue("gap") || cs.getPropertyValue("column-gap") || "16px";
        return parseFloat(gap) || 0;
    }

    function setupSliderForActive() {
        const activeSlider = document.querySelector(".accessory-slider.active");
        if (!activeSlider) return null;

        const track = activeSlider.querySelector(".accessory-products");
        const items = track? Array.from(track.querySelectorAll(".accessory-card")).filter((card) => card.offsetParent !== null): [];

        if (!track || items.length === 0) {
            activeSlider.dataset.sliderPos = "0";
            track.style.transform = "translateX(0px)";
            return null;
        }

        if (!track || items.length === 0) return null;
        if (!activeSlider.dataset.sliderPos) activeSlider.dataset.sliderPos = "0";

        return { slider: activeSlider, track, items };
    }

    /* ---------- Pagination dots ---------- */
    function renderDots(activeObj) {
        const dotsContainer = document.getElementById("accessoryDots");
        if (!dotsContainer) return;

        if (!activeObj) {
            dotsContainer.innerHTML = "";
            return;
        }

        const { items } = activeObj;
        const visible = getVisibleCount();
        const pageCount = Math.max(1, Math.ceil(items.length / visible));

        if (pageCount <= 1) {
            dotsContainer.innerHTML = "";
            return;
        }

        const pos = parseInt(activeObj.slider.dataset.sliderPos, 10) || 0;
        const currentPage = Math.round(pos / visible);

        dotsContainer.innerHTML = "";
        for (let i = 0; i < pageCount; i++) {
            const dot = document.createElement("div");
            dot.className = "dot" + (i === currentPage ? " active" : "");
            dot.addEventListener("click", () => {
                const maxIndex = Math.max(0, items.length - visible);
                activeObj.slider.dataset.sliderPos = String(clamp(i * visible, 0, maxIndex));
                updateTrackTransform(activeObj);
            });
            dotsContainer.appendChild(dot);
        }
    }

    function updateTrackTransform(activeObj) {
        // Pause the MutationObserver first -- everything below writes to the DOM
        // inside the observed section, and without pausing, each write would
        // re-trigger the observer -> call this function again -> loop forever
        // (this is what caused the "Page Unresponsive" freeze).
        sliderObserver?.disconnect();

        // Re-measure the box and update --cards-per-row before anything
        // else, so getVisibleCount() below reflects the current fit.
        updateCardsPerRow();

        if (!activeObj) {
            renderDots(null);
            reconnectSliderObserver();
            return;
        }
        const { slider, track, items } = activeObj;
        const visible = getVisibleCount();
        const gap = getGapPx(track);
        const cardRect = items[0].getBoundingClientRect();
        const cardWidth = cardRect.width;
        const maxIndex = Math.max(0, items.length - visible);

        let pos = parseInt(slider.dataset.sliderPos, 10) || 0;
        pos = clamp(pos, 0, maxIndex);
        slider.dataset.sliderPos = String(pos);

        const shift = (cardWidth + gap) * pos;
        track.style.transform = `translateX(-${shift}px)`;

        items.forEach((card) => card.classList.remove("left-aside"));

        const lastVisibleIndex = pos + visible - 1;
        if (items[lastVisibleIndex]) {
            items[lastVisibleIndex].classList.add("left-aside");
        }

        const prevBtn = document.getElementById("prodPrevBtn");
        const nextBtn = document.getElementById("prodNextBtn");
        if (prevBtn) prevBtn.disabled = pos <= 0;
        if (nextBtn) nextBtn.disabled = pos >= maxIndex;

        renderDots(activeObj);
        reconnectSliderObserver();
    }

    function reconnectSliderObserver() {
        if (!sliderObserver) return;
        const sliderContainer = document.querySelector(".accessory-section");
        if (sliderContainer) {
            sliderObserver.observe(sliderContainer, {
                attributes: true,
                subtree: true,
                childList: true,
            });
        }
    }

    function slideDelta(delta) {
        const activeObj = setupSliderForActive();
        if (!activeObj) return;

        const slider = activeObj.slider;
        const items = activeObj.items;
        const visible = getVisibleCount();

        const maxIndex = Math.max(0, items.length - visible);

        let pos = parseInt(slider.dataset.sliderPos, 10) || 0;
        pos = clamp(pos + visible, 0, maxIndex);
        if (delta < 0) {
            pos = clamp((parseInt(slider.dataset.sliderPos, 10) || 0) - visible, 0, maxIndex);
        }

        slider.dataset.sliderPos = String(pos);
        updateTrackTransform(activeObj);
    }

    document.getElementById("prodPrevBtn")?.addEventListener("click", () => slideDelta(-1));
    document.getElementById("prodNextBtn")?.addEventListener("click", () => slideDelta(+1));

    document.querySelectorAll(".accessory-tab").forEach((tab) => {
        tab.addEventListener("click", () => {
            // Activate tab
            document.querySelectorAll(".accessory-tab").forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");

            // Activate slider
            const target = tab.dataset.tab;
            document.querySelectorAll(".accessory-slider").forEach((s) => s.classList.remove("active"));

            const activeSlider = document.querySelector(`.accessory-slider[data-tab="${target}"]`);
            if (!activeSlider) return;
            if (activeSlider) resetArrowsForTab(activeSlider);
            tab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });

            activeSlider.classList.add("active");
            hardResetSlider(activeSlider);
            requestAnimationFrame(() => {
                const activeObj = setupSliderForActive();
                if (activeObj) updateTrackTransform(activeObj);
            });

            updateLeadTimeText();   // ADD THIS LINE

            updateTabCount();
        });
    });


    const tabScroll = document.getElementById("tabScroll");
    const leftArrow = document.getElementById("leftArrow");
    const rightArrow = document.getElementById("rightArrow");

    function updateArrows() {
        if (!tabScroll) return;
        leftArrow.disabled = tabScroll.scrollLeft <= 5;
        rightArrow.disabled = tabScroll.scrollLeft + tabScroll.clientWidth >= tabScroll.scrollWidth - 5;
    }

    leftArrow?.addEventListener("click", () => {
        tabScroll.scrollBy({ left: -150, behavior: "smooth" });
        setTimeout(updateArrows, 400);
    });

    rightArrow?.addEventListener("click", () => {
        tabScroll.scrollBy({ left: 150, behavior: "smooth" });
        setTimeout(updateArrows, 400);
    });

    tabScroll?.addEventListener("scroll", updateArrows);
    window.addEventListener("load", updateArrows);

    function findCheckboxesInScope(value, el) {
        const slider = el?.closest(".accessory-slider");
        const section = el?.closest(".accessory-section");
        const scope = slider || section || document;
        const scoped = Array.from(scope.querySelectorAll(`input[type="checkbox"][value="${value}"]`));
        const global = Array.from(document.querySelectorAll(`input[type="checkbox"][value="${value}"]`));
        const set = new Set(scoped);
        global.forEach((g) => set.add(g));
        return Array.from(set);
    }

     document.querySelectorAll('.accessory-slider .accessory-products .accessory-card').forEach((card) => {
        const img = card.querySelector('.accessory-image');
        const priceBox = card.querySelector('.accessory-price');
        const storeMoneyFormat = document.querySelector('input#storeMoneyFormat').value;
        card.querySelectorAll(".color-options .color-circle").forEach((colorSwatch) => {
            colorSwatch.addEventListener("click", () => {
                if (colorSwatch.classList.contains("active")) return;
                const colorOptions = colorSwatch.closest(".color-options");
                if (!colorOptions) return;

                colorOptions.querySelectorAll(".color-circle").forEach((swatch) => {
                    swatch.classList.remove("active");
                    const boldVal = swatch.getAttribute("data-variant-id");
                    findCheckboxesInScope(boldVal, colorOptions).forEach((el) => {
                        if (el.checked) el.click();
                    });
                });

                const newImage = colorSwatch.getAttribute('data-image');
                if (newImage && img) {
                   img.src = newImage;
                }                
                const variantId = colorSwatch.getAttribute('data-variant-id');
                if (variantId) {
                  card.setAttribute('data-variant-id', variantId);
                }
                const variantTitle = colorSwatch.getAttribute('data-title');
                if (variantTitle) {
                  card.setAttribute('data-variant-name', variantTitle);
                }
                const variantPrice = colorSwatch.getAttribute('data-price');
                if (variantPrice) {
                  card.setAttribute('data-variant-price', variantPrice);
                  const isFree = variantPrice.toLowerCase() === "free" || variantPrice === "0";
                    if(isFree){
                        priceBox.innerHTML = 'FREE';
                    } else {
                        priceBox.innerHTML = Shopify.formatMoney(variantPrice, storeMoneyFormat);
                    }
                }
                

                colorSwatch.classList.add("active");
                const valueField = colorOptions.querySelector(".accessory-card-value");
                const swatchValue = colorSwatch.getAttribute("data-variant-id");
                if (valueField) valueField.value = swatchValue;

                findCheckboxesInScope(swatchValue, colorOptions).forEach((el) => {
                    if (!el.checked) el.click();
                });

                const sourceCard = colorSwatch.closest(".accessory-card");
                syncColorToActiveCards(sourceCard, swatchValue);
                updateAccessoryCardData();
            });
        });
    });

    function syncSliderCard(originalCard, dataCard, optionId) {
        const cards = document.querySelectorAll(`.accessory-card[data-card="${dataCard}"]`);
        cards.forEach((card) => {
            if (originalCard != card) {
                if (originalCard.classList.contains("active")) {
                    card.classList.add("active");
                } else {
                    card.classList.remove("active");
                }
                const colorCircles = card.querySelectorAll(".color-circle");
                colorCircles.forEach((color) => color.classList.remove("active"));
                const selectedColorCircle = card.querySelector(`.color-circle[data-variant-id="${optionId}"]`);
                if (selectedColorCircle) selectedColorCircle.classList.add("active");
                const selectInput = card.querySelector(`.accessory-card-value[type="hidden"]`);
                if (selectInput) selectInput.value = optionId;
            }
        });
    }

    function hardResetSlider(slider) {
        const track = slider.querySelector(".accessory-products");
        if (!track) return;

        slider.dataset.sliderPos = "0";
        track.style.transition = "none";
        track.style.transform = "translateX(0px)";

        // Force browser reflow
        track.offsetHeight;
        track.style.transition = "";
    }

    function updateTotalPrice(accessoryPrice, isAdding) {
        const totalPrices = document.querySelectorAll(".totalprice");
        const basePriceInput = document.getElementById("base-vaiant-price");
        const accessoryTotalInput = document.getElementById("accessory_card_total");
        let updatedExcTotalPrice;

        let accessoryTotal = accessoryTotalInput.value;
        accessoryTotal = Number(accessoryTotal);
        let baseTotal = basePriceInput.value;
        baseTotal = Number(baseTotal);
        baseTotal = baseTotal - accessoryTotal;

        const accesBasePrice = Number((accessoryPrice * 100).toFixed(0));
        if (!basePriceInput || !totalPrices) return;

        let updatedTotalPrice = parseFloat(basePriceInput.getAttribute("data-inc-base-price")) / 100;
        if (isAdding) {
            updatedTotalPrice += parseFloat(accessoryPrice); // Add accessory price if adding
            accessoryTotal += accesBasePrice; // Add accessory Base price if adding
            console.log(`Adding accessory price: £${accessoryPrice}. New total: £${updatedTotalPrice.toFixed(2)}`);
        } else {
            updatedTotalPrice -= parseFloat(accessoryPrice); // Subtract accessory price if removing
            accessoryTotal -= accesBasePrice; // Subtract accessory Base price if removing
            console.log(`Removing accessory price: £${accessoryPrice}. New total: £${updatedTotalPrice.toFixed(2)}`);
        }

        // Update the hidden input (store the total price in cents)
        basePriceInput.setAttribute("data-inc-base-price", updatedTotalPrice * 100); // Store the total price back in cents
        baseTotal = baseTotal + accessoryTotal;
        basePriceInput.value = baseTotal;
        accessoryTotalInput.value = accessoryTotal;
        updatedExcTotalPrice = parseFloat((updatedTotalPrice / 1.2).toFixed(2));

        // Update the displayed total price
        totalPrices.forEach((price) => {
            price.textContent = `£${updatedTotalPrice.toFixed(2)}`; // Display the updated price
        });
        document.querySelectorAll("#main-price-incl-vat .money").forEach(function (el, index) {
            el.innerHTML = `£${updatedTotalPrice.toFixed(2)}`;
        });

        document.querySelectorAll(".additional-prices .ex-vat-wrapper .money").forEach(function (el, index) {
            el.innerHTML = `£${updatedExcTotalPrice.toFixed(2)}`;
        });
    }

    async function updateAccessoryCardData() {
        const accessoriesSection = document.getElementById("dynamic-accessories-section");
        const deliveriesSection = document.getElementById("dynamic-delivery-options-section");

        // ✅ return ONLY if both are missing
        if (!accessoriesSection && !deliveriesSection) return;

        const activeAccessoryCards = accessoriesSection?.querySelectorAll(".accessory-card.active") || [];
        const activeDeliveryCards = deliveriesSection?.querySelectorAll(".delivery-card.selected") || [];

        const getVal = (id) => document.getElementById(id);

        const accessoryVariantInput = getVal("accessory_card_variant_ids");
        const accessoryProductInput = getVal("accessory_card_product_ids");
        const accessoryPriceInput = getVal("accessory_card_variant_prices");
        const accessoryNameInput = getVal("accessory_card_variant_names");

        const deliveryVariantInput = getVal("delivery_card_variant_ids");
        const deliveryProductInput = getVal("delivery_card_product_ids");
        const deliveryPriceInput = getVal("delivery_card_variant_prices");
        const deliveryNameInput = getVal("delivery_card_variant_names");

        let variantIds = [], productIds = [], prices = [], names = [];

        let accessoryData = { v: [], p: [], pr: [], n: [] };
        let deliveryData = { v: [], p: [], pr: [], n: [] };

        const seen = new Set();

        const process = (cards, target) => {
            cards.forEach(card => {
                const { variantId, productId, variantPrice: price, variantName: name } = card.dataset;

                if (variantId && productId && price && name && !seen.has(variantId)) {
                    seen.add(variantId);

                    variantIds.push(variantId);
                    productIds.push(productId);
                    prices.push(price);
                    names.push(name);

                    target.v.push(variantId);
                    target.p.push(productId);
                    target.pr.push(price);
                    target.n.push(name);
                }
            });
        };

        process(activeAccessoryCards, accessoryData);
        process(activeDeliveryCards, deliveryData);

        // ✅ assign values safely
        if (accessoryVariantInput) accessoryVariantInput.value = accessoryData.v.join(",");
        if (accessoryProductInput) accessoryProductInput.value = accessoryData.p.join(",");
        if (accessoryPriceInput) accessoryPriceInput.value = accessoryData.pr.join(",");
        if (accessoryNameInput) accessoryNameInput.value = accessoryData.n.join(",");

        if (deliveryVariantInput) deliveryVariantInput.value = deliveryData.v.join(",");
        if (deliveryProductInput) deliveryProductInput.value = deliveryData.p.join(",");
        if (deliveryPriceInput) deliveryPriceInput.value = deliveryData.pr.join(",");
        if (deliveryNameInput) deliveryNameInput.value = deliveryData.n.join(",");

        const form = document.querySelector('form.js-product-form.form[action*="/cart/add"]');
        if (!form) return;

        let container = form.querySelector(".form-accessories-container");
        if (!container) {
            container = Object.assign(document.createElement("div"), {
                id: "form_accessories_container",
                className: "form-accessories-container"
            });
            form.appendChild(container);
        }

        const getInput = (name) => {
            let el = container.querySelector(`input[name="${name}"]`);
            if (!el) {
                el = Object.assign(document.createElement("input"), {
                    type: "hidden",
                    name
                });
                container.appendChild(el);
            }
            return el;
        };

                const groupInput = getInput("properties[_accessoryGroupId]");
        const variantInputForm = getInput("properties[_accessoryVariantIds]");
        const productInputForm = getInput("properties[_accessoryProductIds]");
        const priceInputForm = getInput("properties[_accessoryVariantPrices]");
        const nameInputForm = getInput("properties[_accessoryVariantNames]");
        const bundleContentsInput = getInput("properties[_bundleContents]");

        // Build "Starter: item, item | Essential: item, item" for the warehouse
        const bundleText = Array.from(activeAccessoryCards)
            .filter((c) => c.classList.contains("is-bundle-card"))
            .map((c) => {
                const items = Array.from(c.querySelectorAll(".accessory-details-info li"))
                    .map((li) => li.textContent.replace(/\s+/g, " ").trim())
                    .filter(Boolean);
                return (c.dataset.card || "Bundle") + ": " + items.join(", ");
            })
            .join(" | ");
        bundleContentsInput.value = bundleText;

        if (!variantIds.length) {
            [groupInput, variantInputForm, productInputForm, priceInputForm, nameInputForm, bundleContentsInput]
                .forEach(i => i.value = "");
            return;
        }

        if (!groupInput.value) {
            groupInput.value = await generateUniqueAccessoryGroupId();
        } else {
            const isUsed = await validateAccessoryGroupId(groupInput.value);
            if(isUsed) {
                groupInput.value = await generateUniqueAccessoryGroupId();
            }
        }


        variantInputForm.value = variantIds.join(",");
        productInputForm.value = productIds.join(",");
        priceInputForm.value = prices.join(",");
        nameInputForm.value = names.join(",");
    }

    async function generateUniqueAccessoryGroupId() {
        console.log('generateUniqueAccessoryGroupId');
        const generate = () => Math.floor(10000000000 + Math.random() * 90000000000).toString();

        let newId;
        let exists = true;

        do {
            newId = generate();
            exists = await validateAccessoryGroupId(newId);
        } while (exists);

        console.log('newId: ', newId);

        return newId;
    }

    async function validateAccessoryGroupId(id) {
        const res = await fetch("/cart.js");
        const cart = await res.json();

        return cart.items.some((item) => {
            return String(item.properties?._accessoryGroupId) === String(id);
        });
    }


    document.querySelectorAll(".accessory-add-btn").forEach((addButton) => {
        addButton.addEventListener("click", (event) => {
            event.stopPropagation();
            const card = addButton.closest(".accessory-card");

            // ── HARDENED GUARD ──────────────────────────────────────────
            // applyPortholeRules() (and any other "hide this card" rule)
            // sets card.dataset.locked = "true" whenever a card shouldn't
            // be selectable for the currently chosen Desk Top Size. Relying
            // on display:none alone is NOT enough — someone can open
            // DevTools, clear the inline style, and the click handler below
            // would otherwise still run and add the item to the cart.
            // Checking the explicit data-locked flag here means the card
            // must ALSO be un-locked (not just made visible) before this
            // handler will do anything. This raises the bar considerably,
            // though a fully reliable fix still requires server-side
            // validation (cart/checkout) since front-end code can always
            // be bypassed by a sufficiently determined user or a direct
            // /cart/add.js request — see the note at the bottom of this file.
            if (!card || card.dataset.locked === "true") {
                return;
            }
            // ─────────────────────────────────────────────────────────────

            const cardName = card.dataset.card;
            // Special rule for Desk Grommets vs Deluxe Desk Grommets
            // Grommet accessories are mutually exclusive within each pair.
// Add more pairs here if you get more variants later.
const GROMMET_GROUPS = [
    ["Desk Grommets", "Deluxe Desk Grommets"],
    ["2 x Desk Grommets", "2 x Deluxe Desk Grommets"],
];

function getGrommetGroup(name) {
    return GROMMET_GROUPS.find((group) => group.includes(name));
}

// Special rule: only one card per grommet group can be active at a time
const grommetGroup = getGrommetGroup(cardName);
if (grommetGroup && !card.classList.contains("active")) {
    // We're about to turn THIS card on, so turn off any other active
    // card in the same group by clicking its own button — that way
    // price totals, form fields, and slider sync all stay correct.
    document.querySelectorAll('.accessory-card').forEach((otherCard) => {
        const otherName = otherCard.dataset.card;
        if (
            otherCard !== card &&
            grommetGroup.includes(otherName) &&
            otherCard.classList.contains("active")
        ) {
            const otherBtn = otherCard.querySelector(".accessory-add-btn");
            if (otherBtn) {
                otherBtn.click();
                console.log("Unselected other grommet:", otherName);
            }
        }
    });
}

            if (!card) return;
            const slider = card.closest(".accessory-slider");
            const tabName = slider?.dataset.tab;
            const cardDataType = card.dataset.card;

            const priceElement = card.querySelector(".accessory-price span.money");
            let accessoryPrice = priceElement? priceElement.textContent.replace(/[^0-9.-]+/g, "") : "0"; // Clean the price string

            // If the price is marked as "FREE", set the price to 0
            if (accessoryPrice.toLowerCase() === "free" || !accessoryPrice || accessoryPrice === "") {
                accessoryPrice = "0"; // Set to zero if the price is free or missing
            }

            if (
                    tabName === "fire_resistant_foam" ||
                    tabName === "footring" ||
                    tabName === "castors"
                ) {

                    if (!card.classList.contains("active")) {

                        slider.querySelectorAll(".accessory-card.active").forEach((oldCard) => {

                            if (oldCard !== card) {

                                const oldBtn = oldCard.querySelector(".accessory-add-btn");

                                if (oldBtn) {
                                    oldBtn.click();
                                }
                            }
                        });
                    }
                }

                card.classList.toggle("active");
            if (card.classList.contains("active")) {
                addButton.textContent = "Added";
                addButton.classList.add("added"); // <-- FIXED
                updateTotalPrice(accessoryPrice, true);
            } else {
                addButton.textContent = "Add to Desk";
                addButton.classList.remove("added"); // <-- FIXED
                updateTotalPrice(accessoryPrice, false);
            }

            syncAddRemoveAcrossSameProducts(card, card.classList.contains("active"));

            const colorOptions = card.querySelector(".color-options");
            if (colorOptions) {
                const scopeElement = card.closest(".accessory-slider") || card.closest(".accessory-section") || card;

                if (card.classList.contains("active")) {
                    const activeSwatch = colorOptions.querySelector(".color-circle.active");
                    const selectedSwatch = activeSwatch?.dataset.variantId;

                    // colorOptions.querySelectorAll(".color-circle").forEach((s) => s.classList.remove("active"));

                    if (selectedSwatch) {
                        syncSliderCard(card, cardDataType, selectedSwatch);
                    }
                } else {
                    // colorOptions.querySelectorAll(".color-circle").forEach((s) => s.classList.remove("active"));
                    let selectedSwatch = colorOptions.querySelector(".color-circle.active");
                    let selectedSwatchId = selectedSwatch.dataset.variantId;

                    if (!selectedSwatch) {
                        const firstSwatch = colorOptions.querySelector(".color-circle");
                        if (firstSwatch) {
                            firstSwatch.classList.add("active");
                            selectedSwatch = firstSwatch.dataset.id;
                        }
                    }

                    if (selectedSwatch) {
                        syncColorToActiveCards(card, selectedSwatch);
                        syncSliderCard(card, cardDataType, selectedSwatchId);
                    }
                }
            }

            updateTabCount();
            updateAccessoryCardData();
        });
    });

    function tryLoadBold() {
        const boldDefault = document.querySelector('#BOLD_OPTIONS_APP, #BOLD_OPTIONS_CONTAINER, #bold_options_container, .bold_options, .bold_options_app, [id*="BOLD"], [class*="bold"]');
        const target = document.getElementById("bold-control-switch-container");
        if (boldDefault && boldDefault.querySelector(".bold_option")) {
            target.innerHTML = "";
            target.appendChild(boldDefault);
            return true;
        }
        return false;
    }

    let tries = 0;
    const boldPoll = setInterval(() => {
        if (tryLoadBold()) clearInterval(boldPoll);
        tries++;
        if (tries > 30) clearInterval(boldPoll);
    }, 500);

    /* -------------------- PORTHOLE LOGIC (UPDATED) -------------------- */

    const HIDE_PORTHOLE_SIZES = ["Frame Only", "100x60", "120x70"];

    function findPortholes() {
        return Array.from(document.querySelectorAll(".accessory-card")).filter((card) => {
            const txt = card.querySelector(".accessory-title")?.innerText.trim() || "";
            return ( txt.includes("Desk Grommets") || txt.includes("Desk Grommets") || txt.includes("Deluxe Desk Grommets"));
        });
    }

    const portholeCards = findPortholes();

    function applyPortholeRules() {
        // const allowAllSizes = isPortholeExemptProduct();
        const selectedSize = document.querySelector('input[name="Desk Top Size(cm)"]:checked') ?.value || "";
        console.log('selectedSize: ', selectedSize);
        const shouldHideBySize = HIDE_PORTHOLE_SIZES.includes(selectedSize);
        portholeCards.forEach((card) => {
            const addBtn = card.querySelector(".accessory-add-btn");
            if (shouldHideBySize) {
                card.classList.remove("active");
                card.style.display = "none";
                // Belt-and-braces: block clicks/keyboard focus AND set an
                // explicit data flag the add-button handler checks. Do not
                // rely on card.style.display alone — see the guard note in
                // the .accessory-add-btn click handler above for why.
                card.style.pointerEvents = "none";
                card.setAttribute("aria-hidden", "true");
                card.dataset.locked = "true";
                card.querySelectorAll(".color-circle.active").forEach((c) => c.classList.remove("active"));

                if (addBtn) {
                    addBtn.textContent = "Add to Desk";
                    addBtn.classList.remove("added");
                    addBtn.disabled = true;
                }
            } else {
                card.style.display = "";
                card.style.opacity = "1";
                card.style.pointerEvents = "auto";
                card.removeAttribute("aria-hidden");
                card.dataset.locked = "false";
                if (addBtn) addBtn.disabled = false;
                const colorOptions = card.querySelector(".color-options");
                if(!colorOptions.querySelector(".color-circle.active")){
                    const firstSwatch = colorOptions.querySelector(".color-circle");
                    if (firstSwatch && !firstSwatch.classList.contains("active")) {
                        firstSwatch.classList.add("active");
                    }
                }
                if (addBtn && addBtn.textContent === "Add to Desk" && !card.dataset.card.includes('Deluxe Desk Grommets')) {
                    addBtn.click();
                }
            }
        });

        updateTabCount();
    }

    applyPortholeRules();

    document.querySelectorAll('input[name="Desk Top Size(cm)"]').forEach((radio) => {
        radio.addEventListener("change", applyPortholeRules);
    });

    /* =====================================================================
       ADD-TO-CART COMBINATION GUARD
       -----------------------------------------------------------------
       The porthole lock above (data-locked / pointer-events / display)
       protects the accessory CARD. This guard protects the actual
       ADD-TO-CART SUBMISSION itself, which is a much smaller, harder to
       find and disable surface: to bypass THIS, someone has to locate
       and remove this specific submit listener in DevTools, not just
       clear a few inline styles on one card. Every path that ends in
       the product form being submitted (Add to Cart click, Enter key,
       any other submit button on the same form) is forced through this
       one check.

       Still, this is browser JS: it cannot stop a request sent straight
       to /cart/add.js from outside the browser (curl, a script, an app).
       That kind of request never touches this code at all. Real,
       unavoidable enforcement still requires a server-side Cart/Checkout
       Validation Function (see the note at the very end of this file) —
       treat this guard as closing the gap for the browser UI, not as a
       replacement for that.
       ===================================================================== */

    // One rule per exclusion. Add more objects here as new incompatible
    // combinations come up — no need to touch the logic below.
    const INCOMPATIBLE_ACCESSORY_RULES = [
        {
            sizes: ["Frame Only", "100x60", "120x70"],
            // matches "Desk Grommets", "Deluxe Desk Grommets", "2 x Desk Grommets", etc.
            accessoryMatch: (cardName) => (cardName || "").includes("Desk Grommets"),
            message: "Desk Grommets aren't available for the Desk Top Size you've selected. Please remove it or choose a different size before continuing."
        }
    ];

    function validateAccessoryCombination() {

    const selectedSize =
        document.querySelector(
            'input[name="Desk Top Size(cm)"]:checked'
        )?.value?.trim() || "";


    const form =
        document.querySelector(
            'form.js-product-form.form[action*="/cart/add"]'
        );

    if (!form) {
        return { valid: true };
    }


    const groupId =
        form.querySelector(
            'input[name="properties[_accessoryGroupId]"]'
        )?.value?.trim() || "";


    const variantNames =
        form.querySelector(
            'input[name="properties[_accessoryVariantNames]"]'
        )?.value?.trim() || "";


    console.log("===== FINAL ACCESSORY COMBINATION CHECK =====");
    console.log("Desk Top Size:", selectedSize);
    console.log("Accessory Group ID:", groupId);
    console.log("Accessory Variant Names:", variantNames);


    const accessoryNames = variantNames
        .split(",")
        .map(name => name.trim())
        .filter(Boolean);


    for (const rule of INCOMPATIBLE_ACCESSORY_RULES) {

        // Selected size is not restricted
        if (!rule.sizes.includes(selectedSize)) {
            continue;
        }


        // Look inside the ACTUAL submitted accessory list
        const offendingName =
            accessoryNames.find(name =>
                rule.accessoryMatch(name)
            );


        if (offendingName) {

            const offendingCard =
                Array.from(
                    document.querySelectorAll(".accessory-card")
                ).find(card =>
                    (card.dataset.card || "")
                        .toLowerCase()
                        .includes(
                            offendingName
                                .toLowerCase()
                                .split(":")[0]
                                .trim()
                        )
                );


            console.warn(
                "🚫 INVALID ACCESSORY COMBINATION",
                {
                    selectedSize,
                    groupId,
                    offendingName
                }
            );


            return {
                valid: false,
                message: rule.message,
                card: offendingCard
            };
        }
    }


    return {
        valid: true
    };
}

    function showAccessoryComboWarning(message, offendingCard) {

    let banner = document.getElementById("accessory-combo-warning");

    if (!banner) {
        banner = document.createElement("div");
        banner.id = "accessory-combo-warning";
        banner.setAttribute("role", "alert");
        banner.style.cssText = [
            "background:#fdecea",
            "color:#ff3b30",
            "padding:10px 14px",
            "border-radius:6px",
            "margin:12px 0 0",
            "font-size:14px",
            "font-weight:600",
            "line-height:1.4",
            "text-align:left"
        ].join(";");
    }

    const deskSizeContainer = getDeskSizeContainer();
    if (deskSizeContainer && deskSizeContainer.parentNode) {
        deskSizeContainer.parentNode.insertBefore(banner, deskSizeContainer.nextSibling);
    } else {
        const form = document.querySelector('form.js-product-form.form[action*="/cart/add"]');
        if (form && form.parentNode) {
            form.parentNode.insertBefore(banner, form);
        } else {
            document.body.prepend(banner);
        }
    }

    banner.textContent = "Desk Grommets aren't available for this size.";
    banner.style.display = "block";

    banner.scrollIntoView({ behavior: "smooth", block: "center" });

    clearTimeout(banner._timer);
    banner._timer = setTimeout(() => {
        banner.style.display = "none";
    }, 5000);

    if (offendingCard) {
        offendingCard.style.outline = "2px solid #c0392b";
        offendingCard.style.outlineOffset = "2px";
        setTimeout(() => {
            offendingCard.style.outline = "";
            offendingCard.style.outlineOffset = "";
        }, 2500);
    }
}

function hideAccessoryComboWarning() {
    const banner = document.getElementById("accessory-combo-warning");
    if (!banner) return;
    clearTimeout(banner._timer);
    banner.style.display = "none";
}

    // ---- WHY THIS LISTENS ON document, NOT ON THE FORM ITSELF ----
    // Shopify's AJAX product-form theme code (the <product-form> custom
    // element / equivalent) attaches its own "submit" listener directly to
    // this same <form>, and it does so the instant the element is parsed —
    // almost always before this script (which waits for DOMContentLoaded)
    // runs at all. Two listeners on the SAME node fire in the order they
    // were REGISTERED, regardless of capture/bubble — so a listener added
    // here directly on the form would always lose that race and run too
    // late, after the theme's handler has already fired its own fetch to
    // /cart/add.js. This is exactly what was happening before.
    //
    // Listening on document with capture:true sidesteps that race entirely:
    // capturing-phase listeners on an ANCESTOR node always run before any
    // listener (capture or bubble) on the target node itself, no matter
    // which script registered first. document → ... → form is fixed
    // propagation order, so this always gets first look at the event.
    const CART_ADD_FORM_SELECTOR = 'form.js-product-form.form[action*="/cart/add"]';

    document.addEventListener("submit", function (event) {
        const form = event.target;
        if (!form || !form.matches || !form.matches(CART_ADD_FORM_SELECTOR)) return;

        const result = validateAccessoryCombination();
        if (!result.valid) {
            event.preventDefault();
            event.stopPropagation(); // stop it before it ever reaches the form's own listeners
            showAccessoryComboWarning(result.message, result.card);
        } else {
            hideAccessoryComboWarning();
        }
    }, true); // capture: true is what makes this run first — do not remove

        // Hide BOTH warnings the moment the shopper changes anything relevant —
    // Desk Top Size, Desk Top Colour, or any other variant/option change —
    // regardless of whether the new combination is valid or not. If it's
    // still invalid, the next attempted Add to Cart will just show the
    // warning again with a fresh 10-second timer.
    document.addEventListener("change", (e) => {
        if (
            e.target.name === "Desk Top Size(cm)" ||
            e.target.name === "Desk Top Colour" ||
            e.target.closest?.(".product-variants")
        ) {
            hidePortholeWarning();
            hideAccessoryComboWarning();
        }
    });

    document.addEventListener("click", (e) => {
        if (e.target.closest(".accessory-add-btn") || e.target.closest(".color-circle")) {
            hidePortholeWarning();
            setTimeout(() => {
                if (validateAccessoryCombination().valid) hideAccessoryComboWarning();
            }, 0);
        }
    });

    const basePriceInput = document.getElementById("base-vaiant-price");
    const totalPriceDisplay = document.querySelector(".totalprice");
    if (!basePriceInput || !totalPriceDisplay) return;

    // Initialize the variable to store the updated total price (in pounds)
    let updatedTotalPrice = parseFloat(basePriceInput.getAttribute("data-inc-base-price")) / 100; // Convert cents to pounds
    console.log(`Initial main product price: £${updatedTotalPrice.toFixed(2)}`);

    // Function to sync "Added" and "Add" states across similar products
    function syncAddRemoveAcrossSameProducts(sourceCard, isActive) {
        console.log('sourceCard: ',sourceCard);
        const productKey = sourceCard.querySelector(".accessory-title").innerText.trim();
        const sourceData = sourceCard.dataset.card;
        document.querySelectorAll(".accessory-card").forEach((targetCard) => {
            const targetKey = targetCard.querySelector(".accessory-title").innerText.trim();
            const targetData = targetCard.dataset.card;
            if (sourceData === targetData && targetKey === productKey) {
                const targetBtn = targetCard.querySelector(".accessory-add-btn");
                if (isActive) {
                    targetCard.classList.add("active");
                    targetBtn.textContent = "Added";
                    targetBtn.classList.add("added");
                } else {
                    targetCard.classList.remove("active");
                    targetBtn.textContent = "Add to Desk";
                    targetBtn.classList.remove("added");
                }
            }
        });
    }

    // Function to update Add button event listeners
    function updateEventListeners() {
        document.querySelectorAll(".accessory-add-btn").forEach((addButton) => {
            addButton.removeEventListener("click", handleAddButtonClick); // Remove previous listener
            addButton.addEventListener("click", handleAddButtonClick); // Reattach new listener
        });
    }

    function handleAddButtonClick(event) {}

    // Function to reinitialize sliders after variant change
    function reinitializeSliders() {
        const activeSlider = document.querySelector(".accessory-slider.active");
        if (activeSlider) {
            const activeObj = setupSliderForActive();
            if (activeObj) updateTrackTransform(activeObj);
        }
    }

    // Function to reinitialize color swatches after variant change
    function reinitializeColorSwatches() {
        document.querySelectorAll(".color-circle").forEach((circle) => {
            circle.addEventListener("click", () => {
                // Handle color change logic
                // Ensure color is updated in both the accessory card and modal
            });
        });
    }

    // Listen for variant changes and reinitialize after variant change
    document.querySelectorAll(".product-variants select").forEach((select) => {
        select.addEventListener("change", function () {
            setTimeout(() => {
                // Reinitialize the accessory logic after variant change
                updateEventListeners();
                updateTabCount();
                updateAddButtonsOnLoad();
                reinitializeSliders();
                reinitializeColorSwatches();
            }, 100); // Slight delay to ensure DOM update
        });
    });

    // Initial load logic (just as you had before)
    updateEventListeners();

    function hideAccessoryCard() {
        const selected = document.querySelector('[name="Desk Top Size(cm)"]:checked');
        if (!selected) {
            return;
        }

        const size = selected.value.trim();
        const cards = document.querySelectorAll(".accessory-card");
        cards.forEach((card) => {
            const name = card.getAttribute("data-card");
            /* hide these two accessories */
            if (name.includes("Single (USB-A") || name.includes("Single Wireless")) {
                if (size === "100x60" || size === "120x70") {
                    card.style.display = "none";
                } else {
                    card.style.display = "";
                }
            }
        });
    }

    /* run on size change */
    document.addEventListener("change", function (e) {
        if (e.target.name === "Desk Top Size(cm)") {
            setTimeout(hideAccessoryCard, 200);
        }
    });

    hideAccessoryCard();

    /* Initial product-slider render (Prev/Next state + dots) */
    const initialActiveObj = setupSliderForActive();
    if (initialActiveObj) updateTrackTransform(initialActiveObj);

    let sliderResizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(sliderResizeTimeout);
        sliderResizeTimeout = setTimeout(() => {
            const activeObj = setupSliderForActive();
            if (activeObj) updateTrackTransform(activeObj);
        }, 120);
    });

    const sliderContainer = document.querySelector(".accessory-section");
    if (sliderContainer) {
        sliderObserver = new MutationObserver(() => {
            const activeObj = setupSliderForActive();
            if (activeObj) updateTrackTransform(activeObj);
        });
        reconnectSliderObserver();
    }

    // Watches the accessory box's own width directly (theme-editor sidebar
    // toggles, layout reflows, etc. that don't fire a window resize event)
    // and re-fits the card count whenever it changes.
    const cardsBox = document.querySelector(".accessory-slider-container");
    if (cardsBox && typeof ResizeObserver !== "undefined") {
        const cardsResizeObserver = new ResizeObserver(() => {
            const activeObj = setupSliderForActive();
            if (activeObj) {
                updateTrackTransform(activeObj);
            } else {
                updateCardsPerRow();
            }
        });
        cardsResizeObserver.observe(cardsBox);
    }

});

document.addEventListener("DOMContentLoaded", function () {

  const handle = "yo-yo-desk-uno-1";

  if (!window.location.pathname.includes(`/products/${handle}`)) {
    console.log("⛔ Script skipped");
    return;
  }

  console.log("✅ Script running");

  function handleVisibility(selectedValue) {
    console.log("🎯 Selected:", selectedValue);

    const cards = document.querySelectorAll(".accessory-card");

    cards.forEach(card => {
      const name = card.dataset.card;

      if (selectedValue === "100x60") {
        if (name === "Cable Tray (100cm)") {
          card.style.display = "";
        } else if (name === "Cable Tray") {
          card.style.display = "none";
        }
      } else {
        if (name === "Cable Tray") {
          card.style.display = "";
        } else if (name === "Cable Tray (100cm)") {
          card.style.display = "none";
        }
      }

      if (selectedValue === "120x70" || selectedValue === "120x80") {
        if (name === "Cable Basket (90cm)") {
          card.style.display = "";
        } else if (name === "Cable Basket") {
          card.style.display = "none";
        }
      } else {
        if (name === "Cable Basket") {
          card.style.display = "";
        } else if (name === "Cable Basket (90cm)") {
          card.style.display = "none";
        }
      }
    });
  }

  const checked = document.querySelector('input[name="Desk Top Size(cm)"]:checked');
  if (checked) handleVisibility(checked.value);

  document.addEventListener("change", function (e) {
    if (e.target.name === "Desk Top Size(cm)") {
      handleVisibility(e.target.value);
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;

    if (
        path.includes("yo-yo-desk-uno-1")
    ) {
        var reviewTab = document.querySelector('.Tab_Nav .gf_tab[data-index="6"]');
        if (reviewTab) {
            reviewTab.style.display = "none";
        }
    }
});

// custome top
function updateDeluxePlyEdgeColours() {

    const selectedColour = document.querySelector(
        'input[name="Desk Top Colour"]:checked'
    );

    if (!selectedColour) return;

    const desktopColour = selectedColour.value.trim().toLowerCase();

    document.querySelectorAll('.accessory-card').forEach(card => {

        const productName = (card.dataset.card || '').toLowerCase();

        // ONLY Deluxe Ply Edge
        if (!productName.includes('deluxe ply edge')) return;

        const swatches = card.querySelectorAll('.color-circle');

        swatches.forEach(swatch => {

            const colourName = (swatch.title || '')
                .trim()
                .toLowerCase();

            swatch.style.display = '';

            // hide matching colour
            if (
                (desktopColour === 'white' && colourName.includes('white')) ||
                (desktopColour === 'black' && colourName.includes('black')) ||
                (desktopColour === 'light grey' && colourName.includes('light grey'))
            ) {
                swatch.style.display = 'none';

                // if hidden swatch is active select another one
                if (swatch.classList.contains('active')) {

                    swatch.classList.remove('active');

                    const firstVisible = [...swatches].find(
                        s => s.style.display !== 'none'
                    );

                    if (firstVisible) {
                        firstVisible.click();
                    }
                }
            }
        });
    });
}
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateDeluxePlyEdgeColours, 500);
});
document.addEventListener('change', function(e){

    if (e.target.name === 'Desk Top Colour') {

        setTimeout(() => {
            updateDeluxePlyEdgeColours();
        }, 100);
    }

});
function updateLeadTimeText() {
  const leadTime = document.querySelector('.lead-time-text');
  if (!leadTime) return;

  const activeTab = document.querySelector('.accessory-tab.active');

  leadTime.textContent =
    activeTab?.dataset.tab === 'custom_top_options'
      ? '* 4 Week Lead Time'
      : '';
}
document.addEventListener('DOMContentLoaded', function () {
  updateLeadTimeText();
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".color-circle").forEach(function (circle) {
    if (circle.getAttribute("title") === "Default Title") {
      circle.style.visibility = "hidden";
    }
  });
});

/* ============================================================
   OPTIONAL: RRP live-sync on color swatch change.
   Append this to the END of bold-product-card.js if you want
   the RRP to update when a shopper picks a different color.
   Self-contained + try/catch guarded so a failure here can
   never break the slider, tabs, or add-to-cart logic above.
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
    try {
        const storeMoneyFormat = document.querySelector('input#storeMoneyFormat')?.value;
        if (!storeMoneyFormat) return;

        function updateRrpPrice(card, comparePrice, price) {
            const rrpEl = card.querySelector('.accessory-rrp-price');
            const priceEl = card.querySelector('.accessory-price');
            const swatchRow = card.querySelector('.color-swatch-row');
            const priceBox = card.querySelector('.price-qty-box');
            if (!rrpEl) return;

            const cp = parseFloat(comparePrice);
            const p = parseFloat(price);
            const hasRrp = !!(cp && p && cp > p);

            if (hasRrp) {
                rrpEl.style.display = '';
                rrpEl.innerHTML = 'RRP: <s>' + Shopify.formatMoney(comparePrice, storeMoneyFormat) + '</s>';
            } else {
                rrpEl.style.display = 'none';
            }

            // Swap places: when RRP is available, the regular price moves up
            // into the swatch row and the RRP moves down into the ADD row.
            // When not available, restore the original layout (price in the ADD row).
            if (swatchRow && priceBox && priceEl) {
                if (hasRrp) {
                    swatchRow.appendChild(priceEl);
                    priceBox.appendChild(rrpEl);
                } else {
                    priceBox.appendChild(priceEl);
                    swatchRow.appendChild(rrpEl);
                }
            }
        }

        // Listen for swatch clicks (capturing, so it runs after your
        // existing handlers have already set data-variant-price).
        document.querySelectorAll('.accessory-card .color-circle').forEach((swatch) => {
            swatch.addEventListener('click', () => {
                setTimeout(() => {
                    try {
                        const card = swatch.closest('.accessory-card');
                        if (!card) return;
                        updateRrpPrice(card, swatch.getAttribute('data-compare-price'), card.dataset.variantPrice);
                    } catch (e) { /* fail silently, never break the page */ }
                }, 0);
            });
        });
    } catch (e) {
        // Fail silently — RRP sync is a nice-to-have, not critical.
    }
});

/* ============================================================
   IMPORTANT — read this before relying on this file alone
   ============================================================
   Everything above raises the bar against a casual DOM-inspector
   bypass (clearing display:none, re-enabling a button) by tying
   the add-to-desk click handler to an explicit data-locked flag
   that only applyPortholeRules() controls.

   It does NOT stop:
   - Someone deleting the data-locked attribute itself via DevTools
   - A direct POST to /cart/add.js with the excluded variant ID
   - Any request that bypasses this storefront JS entirely

   Front-end code can never be a trust boundary. To fully close
   this, the Desk Top Size + porthole-accessory combination needs
   to be validated where the order is actually created:
   - Shopify Plus: a Cart/Checkout Validation Function that reads
     the "Desk Top Size(cm)" line item property and blocks
     checkout if an excluded accessory is present for that size.
   - Non-Plus: an orders/create webhook or app-proxy endpoint that
     audits/blocks the combination server-side.
   ============================================================ */

   /* ============================================================
   BUNDLE CARDS: item count, "What's inside" list, upsell strip
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
   
try {
    const moneyFmt = document.querySelector("input#storeMoneyFormat")?.value;

    // Only select bundle cards inside the Bundle tab
    const cards = Array.from(
        document.querySelectorAll(
            '.accessory-slider[data-tab="bundle"] .accessory-card.is-bundle-card'
        )
    );

    cards.forEach((card, i) => {
        const src = card.querySelector(".accessory-details-info");
        const lis = src ? Array.from(src.querySelectorAll("li")) : [];
        const count = lis.length;

        // Display item count
        const countEl = card.querySelector(".bc-count");
        if (countEl) {
            countEl.textContent = count ? count + " ITEMS" : "";
        }

        const inside = card.querySelector(".bc-inside");
        const list = card.querySelector(".bc-inside-list");
        const label = card.querySelector(".info-pill-text");

        if (!count) {
            inside?.remove();
        } else {
            // Update label only for Bundle tab cards
            if (label) {
                label.textContent = "What's Inside ("+ count + " items)";
            }

            // Build the list of included items
            if (list) {
                list.innerHTML = "";

                lis.forEach((li) => {
                    const text = li.textContent.replace(/\s+/g, " ").trim();
                    const m = text.match(/^(\d+)\s*[×x]\s*(.+)$/i);

                    const qty = m ? m[1] : "1";
                    const name = (m ? m[2] : text)
                        .split(/\s+[—–-]\s+/)[0];

                    const item = document.createElement("li");

                    item.textContent =
                        (qty !== "1" ? qty + " × " : "") + name;

                    list.appendChild(item);
                });
            }

            // Toggle the included-items list
            const toggle = card.querySelector(".bc-inside-toggle");

            if (toggle && inside) {
                toggle.onclick = (e) => {
                    e.stopPropagation();

                    const open = inside.classList.toggle("open");

                    toggle.setAttribute("aria-expanded", open);

                    const icon = toggle.querySelector(".bc-inside-icon");
                    if (icon) {
                        icon.textContent = open ? "−" : "+";
                    }
                };
            }
        }

        // Calculate the upsell price difference
        const upsellEl = card.querySelector(".bc-upsell");
        const text = card.dataset.upsell;
        const next = cards[i + 1];

        if (
            upsellEl &&
            text &&
            next &&
            moneyFmt &&
            window.Shopify?.formatMoney
        ) {
            const diff =
                Number(next.dataset.variantPrice) -
                Number(card.dataset.variantPrice);

            if (diff > 0) {
                upsellEl.innerHTML =
                    '<div class="bc-upsell-inner">↑ ' +
                    text +
                    " for <b>" +
                    Shopify.formatMoney(diff, moneyFmt) +
                    "</b> more</div>";
            }
        }
    });
} catch (e) {
    console.warn("Bundle card enhance failed", e);
}

});
/* ============================================================
   COMPARE BUNDLES popup (built from the bundle cards)
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
    try {
        const btn = document.getElementById("bcCompareBtn");
        if (!btn) return;

        const moneyFmt = document.querySelector("input#storeMoneyFormat")?.value;
        const fmt = (v) =>
            window.Shopify && Shopify.formatMoney && moneyFmt
                ? Shopify.formatMoney(v, moneyFmt)
                : "£" + (Number(v) / 100).toFixed(2);
        const esc = (s) =>
            String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

        let overlay = null;

        function getBundles() {
            const cards = Array.from(
                document.querySelectorAll('.accessory-slider[data-tab="bundle"] .accessory-card.is-bundle-card')
            );
            return cards.map((card) => {
                const activeSwatch = card.querySelector(".color-options .color-circle.active");
                const price = Number(card.dataset.variantPrice) || 0;
                const cp = parseFloat(activeSwatch?.dataset.comparePrice) || 0;

                const items = {};
                card.querySelectorAll(".accessory-details-info li").forEach((li) => {
                    const text = li.textContent.replace(/\s+/g, " ").trim();
                    const m = text.match(/^(\d+)\s*[×x]\s*(.+)$/i);
                    const qty = m ? parseInt(m[1], 10) : 1;
                    const name = (m ? m[2] : text).split(/\s+[—–-]\s+/)[0].trim();
                    if (name) items[name.toLowerCase()] = { name: name, qty: qty };
                });

                return {
                    card: card,
                    title: card.querySelector(".accessory-title")?.textContent.replace(/\s+/g, " ").trim() || "",
                    img: card.querySelector(".accessory-image")?.src || "",
                    price: price,
                    compare: cp > price ? cp : 0,
                    popular: card.classList.contains("bc-popular"),
                    items: items
                };
            });
        }

        function build() {
            const bundles = getBundles();
            if (!bundles.length) return null;

            // union of all item names, in first-seen order
            const allKeys = [];
            const labels = {};
            bundles.forEach((b) =>
                Object.keys(b.items).forEach((k) => {
                    if (allKeys.indexOf(k) === -1) {
                        allKeys.push(k);
                        labels[k] = b.items[k].name;
                    }
                })
            );

            let html = '<div class="bc-cmp-box" role="dialog" aria-modal="true">';
            html += '<h3 class="bc-cmp-title">Compare bundles</h3>';
            html += '<button type="button" class="bc-cmp-close" aria-label="Close">×</button>';
            html += '<div class="bc-cmp-scroll"><table class="bc-cmp-table"><thead><tr><th class="bc-cmp-feature"></th>';

            bundles.forEach((b) => {
                html += '<th class="' + (b.popular ? "bc-cmp-pop" : "") + '">';
                html += '<img class="bc-cmp-img" src="' + esc(b.img) + '" alt="">';
                html += '<div class="bc-cmp-name">' + esc(b.title) + "</div>";
                if (b.popular) html += '<span class="bc-cmp-badge">Most Popular</span>';
                html += "</th>";
            });
            html += "</tr></thead><tbody>";

            // price row
            html += '<tr><td class="bc-cmp-feature">Price</td>';
            bundles.forEach((b) => {
                html += '<td class="' + (b.popular ? "bc-cmp-pop" : "") + '"><div class="bc-cmp-price">' + fmt(b.price) + "</div>";
                if (b.compare) html += '<div class="bc-cmp-worth">Worth <s>' + fmt(b.compare) + "</s></div>";
                html += "</td>";
            });
            html += "</tr>";

            // saving row
            html += '<tr><td class="bc-cmp-feature">You save</td>';
            bundles.forEach((b) => {
                html += '<td class="' + (b.popular ? "bc-cmp-pop" : "") + '">';
                html += b.compare ? '<span class="bc-cmp-save">Save ' + fmt(b.compare - b.price) + "</span>" : "—";
                html += "</td>";
            });
            html += "</tr>";

            // item rows
            allKeys.forEach((k) => {
                html += '<tr><td class="bc-cmp-feature">' + esc(labels[k]) + "</td>";
                bundles.forEach((b) => {
                    const it = b.items[k];
                    html += '<td class="' + (b.popular ? "bc-cmp-pop" : "") + '">';
                    html += it
                        ? '<span class="bc-cmp-yes">✓' + (it.qty > 1 ? ' <small>' + it.qty + " ×</small>" : "") + "</span>"
                        : '<span class="bc-cmp-no">—</span>';
                    html += "</td>";
                });
                html += "</tr>";
            });

            // add buttons row
            html += '<tr><td class="bc-cmp-feature"></td>';
            bundles.forEach((b, i) => {
                html += '<td class="' + (b.popular ? "bc-cmp-pop" : "") + '">';
                html += '<button type="button" class="bc-cmp-add" data-idx="' + i + '">Add to Desk</button></td>';
            });
            html += "</tr></tbody></table></div></div>";

            const el = document.createElement("div");
            el.className = "bc-cmp-overlay";
            el.innerHTML = html;
            document.body.appendChild(el);

            el.addEventListener("click", function (e) {
                if (e.target === el || e.target.closest(".bc-cmp-close")) {
                    closeCompare();
                    return;
                }
                const addBtn = e.target.closest(".bc-cmp-add");
                if (addBtn) {
                    const b = bundles[Number(addBtn.dataset.idx)];
                    const cardBtn = b.card.querySelector(".accessory-add-btn");
                    if (cardBtn && !b.card.classList.contains("active")) cardBtn.click();
                    closeCompare();
                }
            });

            el._bundles = bundles;
            return el;
        }

        function syncAddButtons() {
            if (!overlay) return;
            overlay.querySelectorAll(".bc-cmp-add").forEach((b) => {
                const card = overlay._bundles[Number(b.dataset.idx)].card;
                const on = card.classList.contains("active");
                b.textContent = on ? "Added" : "Add to Desk";
                b.classList.toggle("added", on);
            });
        }

        function openCompare() {
            if (overlay) overlay.remove(); // rebuild so prices/state are always fresh
            overlay = build();
            if (!overlay) return;
            syncAddButtons();
            overlay.classList.add("is-open");
            document.body.classList.add("modal-open");
        }

        function closeCompare() {
            if (!overlay) return;
            overlay.classList.remove("is-open");
            document.body.classList.remove("modal-open");
        }

        btn.addEventListener("click", openCompare);
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") closeCompare();
        });
    } catch (e) {
        console.warn("Compare bundles failed", e);
    }
});


(function () {
  console.log('[Bundle Image Debug] Script loaded');

  function updateErgoFlowBundleImage() {
    const bundleItems = document.querySelectorAll('.bundle-item');

    console.log(
      '[Bundle Image Debug] Bundle items found:',
      bundleItems.length
    );

    bundleItems.forEach(function (item, index) {
      const productLink = item.querySelector('.bundle-item-name a');
      const productImage = item.querySelector('.bundle-item-img img');

      console.log(`[Bundle Image Debug] Item ${index + 1}:`, {
        item: item,
        productLinkFound: !!productLink,
        productImageFound: !!productImage
      });

      if (!productLink || !productImage) {
        console.warn(
          `[Bundle Image Debug] Item ${index + 1}: Link or image missing`
        );
        return;
      }

      const productName = productLink.textContent.trim();

      console.log(
        `[Bundle Image Debug] Item ${index + 1} product name:`,
        productName
      );

      if (
        productName.toLowerCase() ===
        'ergoflow ergonomic task chair'.toLowerCase()
      ) {
        const newImageUrl =
          'https://yo-yodesk.co.uk/cdn/shop/files/Ergoflow_4_700x.jpg?v=1787135679';

        console.log('[Bundle Image Debug] ErgoFlow product matched');
        console.log('[Bundle Image Debug] Old image:', productImage.src);

        productImage.src = newImageUrl;

        console.log('[Bundle Image Debug] New image:', productImage.src);

        productImage.onload = function () {
          console.log('[Bundle Image Debug] Image loaded successfully');
        };

        productImage.onerror = function () {
          console.error(
            '[Bundle Image Debug] Failed to load image:',
            newImageUrl
          );
        };
      }
    });
  }

  // Run immediately when the script executes.
  updateErgoFlowBundleImage();

  // Run again after the page finishes loading.
  window.addEventListener('load', updateErgoFlowBundleImage);

  // Watch for bundle items inserted or updated dynamically.
  const observer = new MutationObserver(function () {
    updateErgoFlowBundleImage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('[Bundle Image Debug] MutationObserver started');
})();
bundle-item